'use client';
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import PasswordGate from './PasswordGate';
import TopNav from './TopNav';
import BottomNav from './BottomNav';
import { Toaster } from 'sonner';
import { PipelineProvider } from '@/contexts/PipelineContext';

interface AppShellProps {
  children: React.ReactNode;
}

export default function AppShell({ children }: AppShellProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checked, setChecked] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const auth = sessionStorage.getItem('orbital_auth');
    if (auth === 'true') setIsAuthenticated(true);
    setChecked(true);
  }, []);

  const handleAuthenticated = () => {
    sessionStorage.setItem('orbital_auth', 'true');
    setIsAuthenticated(true);
  };

  if (!checked) return null;

  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            color: 'var(--text)',
            fontFamily: 'var(--font-dm-sans)',
            fontSize: '14px',
          },
        }}
      />
      {!isAuthenticated && <PasswordGate onAuthenticated={handleAuthenticated} />}
      <PipelineProvider>
        <div className={!isAuthenticated ? 'pointer-events-none select-none blur-sm' : ''}>
          <TopNav
            onHistoryClick={() => router.push('/history')}
            onSetupClick={() => router.push('/setup')}
          />
          <main
            className="mx-auto px-4 sm:px-6 pb-24 sm:pb-12"
            style={{ maxWidth: '1000px', paddingTop: '32px' }}
          >
            {children}
          </main>
          <BottomNav />
        </div>
      </PipelineProvider>
    </>
  );
}